import ModalCreateAccount from './ModalCreateAccount';

export { ModalCreateAccount };
export default ModalCreateAccount;
